export const light = {
	"bgPrimary": "#FFF",
	"bgSecondary": "#D1D6E0",
	"primary": "#000",
	"secondary": "#888686",
	"progress": "#3348c5",
	"border": "#D1D6E0",
	"borderHover": "#000",
	"overlay": "rgba(10,12,15,0.25)",
	"shadow": "rgba(33, 32, 32, 0.75)",
	"bgHotspot": "#b4c9f3",
};

export const dark = {
	"bgPrimary": "#000",
	"bgSecondary": "#12171d",
	"primary": "#FFF",
	"secondary": "#dddddd",
	"progress": "#0d9aff",
	"border": "#3D475C",
	"borderHover": "#FFF",
	"overlay": "rgba(10,12,15,0.25)",
	"shadow": "rgba(204,202,202,0.75)",
	"bgHotspot": "#255ccc",
};

export default {
	light,
	dark,
};
